module.exports = __webpack_public_path__ + "8424829d296bf95b166c38d8530e40af.pdf";